// extracted by mini-css-extract-plugin
module.exports = {"btnBox":"actionsBtn_btnBox__9Fv3u","btnClose":"actionsBtn_btnClose__30pqi","btnOpen":"actionsBtn_btnOpen__dfHOh"};